import styled from 'styled-components';

export const HeaderWrapper = styled.header`
    background-color: #1e2129;
`;

export const HeaderImage = styled.img<{ marginTop: string }>`
    display: block;
    width: 100%;
    margin-top: ${({ marginTop }) => marginTop || 0};
`;
